import { isSupportedBrowser, presentExternalBrowser } from '@el5/native-api'
import type { PropsWithChildren } from 'react'

const getLinkProps = (link: string) => {
  if (isSupportedBrowser()) {
    return { onClick: () => presentExternalBrowser(link) }
  }

  return {
    href: link,
    target: '_blank',
  }
}

interface ExternalLinkProps {
  href: string
  className?: string
}

export const ExternalLink = ({
  href,
  className,
  children,
}: PropsWithChildren<ExternalLinkProps>) => {
  return (
    <a {...getLinkProps(href)} className={className}>
      {children}
    </a>
  )
}
